import {
  GET_CASES,
  GET_CASES_IMPLICATED,
  GET_CASES_RECEIVES,
  GET_CASES_DOCUMENTS,
  GET_CASES_IMPLICATED_DETAIL,
  GET_CASES_BRAND,
  GET_CASES_CAR_TYPE,
  GET_CASES_COMPANY,
  GET_CASES_COMUNE,
  GET_CASES_SURE,
  POST_CASES_BITACORA,
  CASES_ERROR,
  POST_CASES_IMPLICADO,
  GET_CASES_COUNTRY,
  CLEAN_STATE
} from '../types'

const initialState = {
  cases: [],
  receives: [],
  implicated: [],
  documents: [],
  cbSure: [],
  cbBrand: [],
  cbCarType: [],
  cbCountry: [],
  cbCompany: [],
  cbComune: [],
  errors: '',
  response: '',
  implicatedDetail: [],
  loading: true
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CASES_RECEIVES:
      return {
        ...state,
        receives: action.payload,
        loading: false
      }
    case GET_CASES:
      return {
        ...state,
        cases: action.payload,
        loading: false
      }
    case GET_CASES_IMPLICATED:
      return {
        ...state,
        implicated: action.payload,
        loading: false
      }
    case GET_CASES_IMPLICATED_DETAIL:
      return {
        ...state,
        implicatedDetail: action.payload,
        loading: false
      }
    case GET_CASES_DOCUMENTS:
      return {
        ...state,
        documents: action.payload,
        loading: false
      }
    case GET_CASES_SURE:
      return {
        ...state,
        cbSure: action.payload,
        loading: false
      }
    case GET_CASES_COMPANY:
      return {
        ...state,
        cbCompany: action.payload,
        loading: false
      }
    case GET_CASES_CAR_TYPE:
      return {
        ...state,
        cbCarType: action.payload,
        loading: false
      }
    case GET_CASES_BRAND:
      return {
        ...state,
        cbBrand: action.payload,
        loading: false
      }
    case GET_CASES_COMUNE:
      return {
        ...state,
        cbComune: action.payload,
        loading: false
      }
    case GET_CASES_COUNTRY:
      return {
        ...state,
        cbCountry: action.payload,
        loading: false
      }
    case CASES_ERROR:
      return {
        ...state,
        errors: action.payload,
        loading: false
      }
    case POST_CASES_BITACORA:
      return {
        ...state,
        response: action.payload,
        loading: false
      }
    case POST_CASES_IMPLICADO:
      return {
        ...state,
        response: action.payload,
        loading: false
      }
    case CLEAN_STATE:
      return {
        ...state,
        cases: [],
        receives: [],
        implicated: [],
        documents: [],
        cbSure: [],
        cbBrand: [],
        cbCarType: [],
        cbCountry: [],
        cbCompany: [],
        cbComune: [],
        errors: '',
        response: '',
        implicatedDetail: [],
        loading: true
      }

    default:
      return state
  }
}
